module.exports = __webpack_public_path__ + "media/images/athletes/2172-a0fd08e3ce31b22e6a4f23e2d7cc9f98.png";